// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"49":"component---src-pages-about-tsx","218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"49":"1482487033a1d6d9f473","218":"c1f688f3951697634498","691":"e2f7ac3b5724aeb16dd0"}[chunkId] + ".js";
};